// extracted by mini-css-extract-plugin
module.exports = {"DesktopPage":"DocPage-module--DesktopPage--2PEN7","MobileNavBar":"DocPage-module--MobileNavBar--2NE90","MobileNavHeader":"DocPage-module--MobileNavHeader--2jmh7"};